<template>
    <div class="config-objective-one">
        <div class="config-objective-card rounder-8 mb-4">
            <div class="product-info-header">
                <span class="product-sku-badge">{{ propHead.row.sku }}</span>
                <span class="product-name-text">{{ propHead.row.long_name }}</span>
            </div>

            <div class="mb-4">
                <label class="form-label fw-600 size-13 text-secondary mb-2">OBJETIVO DE OPTIMIZACIÓN</label>
                <select 
                    class="form-select fw-600 size-16" 
                    v-model="selectedGoal"
                >
                    <option disabled value="">Seleccione un objetivo</option>
                    <option value="ventas">Ventas</option>
                    <option :value="isMarkup ? 'markup' : 'margen'">{{ isMarkup ? 'Markup' : 'Margen' }}</option>
                    <option value="stock">Stock</option>
                    <option value="competidor">Competidores</option>
                </select>
                <small class="text-secondary size-12 mt-2 d-block">El objetivo guía las recomendaciones de precios del motor IA</small>
            </div>
        </div>

        <div class="config-objective-current p-3 bg-white rounder-8 border mb-4" v-if="propHead.row">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <span class="size-13 text-secondary">Objetivo actual del producto</span>
                    <h4 class="fw-600 size-20 mb-0 mt-1">
                        <span 
                            :class="[
                                'objective-goal-badge',
                                getGoalBadgeClass(propHead.row.goal)
                            ]"
                        >
                            <img 
                                :src="getGoalIcon(propHead.row.goal)" 
                                alt="icon" 
                                class="objective-goal-icon"
                            />
                            {{ getGoalLabel(propHead.row.goal) }}
                        </span>
                    </h4>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-end gap-2">
            <button class="btn btn-success fw-400 px-4" @click="saveObjective" :disabled="saving">
                <span v-if="saving">Guardando...</span>
                <span v-else>Guardar</span>
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { shouldShowAsRecommender } from '../../../../../utils/servicesValidation.js'

export default {
    name: 'config-objective-one',
    props: {
        propHead: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            selectedGoal: '',
            saving: false,
        };
    },
    computed: {
        ...mapGetters([
            "authentication_user",
        ]),
        isMarkup() {
            const result = shouldShowAsRecommender(this.authentication_user);
            return !result.serviceTypeRecommender && !result.neitherService;
        },
    },
    created() {
        this.loadCurrentGoal();
    },
    methods: {
        ...mapActions(['updateWithoutLoading']),
        loadCurrentGoal() {
            const row = this.propHead.row;
            if (row) {
                this.selectedGoal = row.goal || '';
            }
        },
        getGoalBadgeClass(goal) {
            const classes = {
                'ventas': 'objective-goal-ventas',
                'margen': 'objective-goal-margen',
                'markup': 'objective-goal-markup',
                'stock': 'objective-goal-stock',
                'competidor': 'objective-goal-competidor',
            };
            return classes[goal] || 'objective-goal-none';
        },
        getGoalIcon(goal) {
            const icons = {
                'ventas': '/icons/lightning-recomendation.svg',
                'margen': '/icons/chartLine-recomendation.svg',
                'markup': '/icons/chartLine-recomendation.svg',
                'stock': '/icons/package-recomendation.svg',
                'competidor': '/icons/storefront-recomendation.svg',
            };
            return icons[goal] || '/icons/alert-select.svg';
        },
        getGoalLabel(goal) {
            if (!goal || goal === 'ninguno') return 'No Definido';
            if (goal === 'ventas') return 'Ventas';
            if (goal === 'margen') return 'Margen';
            if (goal === 'markup') return 'Markup';
            if (goal === 'stock') return 'Stock';
            if (goal === 'competidor') return 'Competidores';
            return goal;
        },
        saveObjective() {
            if (!this.selectedGoal) {
                this.$notification.error('Debe seleccionar un objetivo de optimización.', { timer: 5, showCloseIcn: true });
                return;
            }
            this.saving = true;
            const data = {
                id: this.propHead.row.id,
                goal: this.selectedGoal,
            };
            this.updateWithoutLoading({
                url: `/api/products/config_objective/update/`,
                params: data,
            }).then(() => {
                this.saving = false;
                this.$emit('refrest');
                this.$notification.success('Objetivo actualizado correctamente.', { timer: 5, showCloseIcn: true });
            }).catch((error) => {
                this.saving = false;
                if (error.status == 400) {
                    this.$notification.error(error.data.message || 'Error al guardar el objetivo.', { timer: 5, showCloseIcn: true });
                } else {
                    this.$notification.error('Error al guardar el objetivo.', { timer: 5, showCloseIcn: true });
                }
            });
        },
    }
};
</script>

<style scoped>
.config-objective-card {
    background: #ffffff;
}

.product-info-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
    margin-bottom: 16px;
}

.product-sku-badge {
    display: inline-block;
    background: #f3f4f6;
    color: #6b7280;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 4px;
    white-space: nowrap;
}

.product-name-text {
    font-size: 0.9rem;
    font-weight: 500;
    color: #374151;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.form-select:focus {
    border-color: #1AA179;
    box-shadow: 0 0 0 0.2rem rgba(26, 161, 121, 0.25);
}

.btn-success {
    background-color: #1AA179 !important;
    border-color: #1AA179 !important;
}

.btn-success:hover:not(:disabled) {
    background-color: #158a65 !important;
    border-color: #158a65 !important;
}

.btn-success:disabled {
    opacity: 0.65;
}

.objective-goal-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    border-radius: 999px;
    font-size: 0.85rem;
    font-weight: 600;
    border: 1px solid transparent;
}

.objective-goal-icon {
    width: 16px;
    height: 16px;
}

.objective-goal-ventas {
    background: #E3F2FD;
    color: #1565C0;
    text-transform: capitalize;
}

.objective-goal-margen {
    background: #F0E5FF;
    color: #6B21A8;
    text-transform: capitalize;
}

.objective-goal-markup {
    background: #F0E5FF;
    color: #6B21A8;
    text-transform: capitalize;
}

.objective-goal-stock {
    background: #FFF3CD;
    color: #CC9A06;
    text-transform: capitalize;
}

.objective-goal-competidor {
    background: #FDE2E4;
    color: #B91C1C;
    text-transform: capitalize;
}

.objective-goal-none {
    background: #E9ECEF;
    color: #6C757D;
    text-transform: capitalize;
}
</style>
